// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container__TIRo3 {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.login_container-left__PGDNH {
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.login_container-left-content__V9iSG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  height: 100%;
}

.login_header-container__LQhrr {
  display: flex;
  justify-content: space-between;
}

.login_container-right__Ewwbm {
  background-color: var(--secondary-background-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
}

.login_container-right-content__Z7i34 {
  max-width: 500px;
  display: grid;
  grid-template-rows: repeat(3, min-content);
  gap: 24px;
  text-align: center;
}

.login_animation__hQlrW {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_wrapper__mN1Nq {
  display: grid;
  align-items: center;
  justify-content: center;
  text-align: center;
  grid-template-rows: auto 1fr 1fr;
  grid-template-columns: 1fr;
  max-width: 418px;
  width: 100%;
  gap: 48px;
}

.login_wrapper-form__GJrRT {
  display: grid;
  grid-template-rows: auto auto;
  text-align: start;
  gap: 16px;
}

.login_wrapper-actions__BHU3Z {
  display: grid;
  grid-template-rows: auto auto 24px 1fr;
  align-items: center;
  gap: 12px;
}

.login_checkbox-link-container__gX9WP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.login_checkbox-wrapper__semla {
  display: flex;
  align-items: center;
  gap: 4px;
}

.login_forgot-password__tAZX7 {
  font-size: 14px;
  color: var(--primary-text-color);
  text-decoration: none;
  border-bottom: 1px solid var(--primary-text-color);
}

.login_registration__GRv\\+i {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  align-items: center;
  gap: 4px;
}

.login_registration-link__2gloN {
  color: var(--tertiary-text-color);
}

.login_footer-actions__0G9ww {
  display: grid;
  align-items: end;
  height: 100%;
}

.login_footer-actions-wrapper__yiRAw {
  display: grid;
  grid-template-rows: 1fr 24px 1fr;
  align-items: center;
  padding: 24px;
}

.login_separator__b\\+LEr {
  width: 100%;
  height: 0;
  border: 0;
}

.login_separator-tertiary__\\+vZDv {
  border-top: 1px solid var(--tertiary-accent-text-color);
}

.login_separator-secondary__fmCJ8 {
  border-top: 1px solid var(--primary-border-color);
}

.login_description__atRgl {
  color: var(--white-text-color);
}

.login_illustration__6hjjb {
  margin: 0 auto;
}

@media (max-width: 980px) {
  .login_container__TIRo3 {
    grid-template-columns: 1fr;
  }

  .login_container-left-content__V9iSG {
    padding: 0;
  }

  .login_checkbox-link-container__gX9WP {
    align-items: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;EACT,SAAS;AACX;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.container-left {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n}\n\n.container-left-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  height: 100%;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.container-right {\n  background-color: var(--secondary-background-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 24px;\n}\n\n.container-right-content {\n  max-width: 500px;\n  display: grid;\n  grid-template-rows: repeat(3, min-content);\n  gap: 24px;\n  text-align: center;\n}\n\n.animation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wrapper {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  grid-template-rows: auto 1fr 1fr;\n  grid-template-columns: 1fr;\n  max-width: 418px;\n  width: 100%;\n  gap: 48px;\n}\n\n.wrapper-form {\n  display: grid;\n  grid-template-rows: auto auto;\n  text-align: start;\n  gap: 16px;\n}\n\n.wrapper-actions {\n  display: grid;\n  grid-template-rows: auto auto 24px 1fr;\n  align-items: center;\n  gap: 12px;\n}\n\n.checkbox-link-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.forgot-password {\n  font-size: 14px;\n  color: var(--primary-text-color);\n  text-decoration: none;\n  border-bottom: 1px solid var(--primary-text-color);\n}\n\n.registration {\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  align-items: center;\n  gap: 4px;\n}\n\n.registration-link {\n  color: var(--tertiary-text-color);\n}\n\n.footer-actions {\n  display: grid;\n  align-items: end;\n  height: 100%;\n}\n\n.footer-actions-wrapper {\n  display: grid;\n  grid-template-rows: 1fr 24px 1fr;\n  align-items: center;\n  padding: 24px;\n}\n\n.separator {\n  width: 100%;\n  height: 0;\n  border: 0;\n}\n\n.separator-tertiary {\n  border-top: 1px solid var(--tertiary-accent-text-color);\n}\n\n.separator-secondary {\n  border-top: 1px solid var(--primary-border-color);\n}\n\n.description {\n  color: var(--white-text-color);\n}\n\n.illustration {\n  margin: 0 auto;\n}\n\n@media (max-width: 980px) {\n  .container {\n    grid-template-columns: 1fr;\n  }\n\n  .container-left-content {\n    padding: 0;\n  }\n\n  .checkbox-link-container {\n    align-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `login_container__TIRo3`,
	"container-left": `login_container-left__PGDNH`,
	"container-left-content": `login_container-left-content__V9iSG`,
	"header-container": `login_header-container__LQhrr`,
	"container-right": `login_container-right__Ewwbm`,
	"container-right-content": `login_container-right-content__Z7i34`,
	"animation": `login_animation__hQlrW`,
	"wrapper": `login_wrapper__mN1Nq`,
	"wrapper-form": `login_wrapper-form__GJrRT`,
	"wrapper-actions": `login_wrapper-actions__BHU3Z`,
	"checkbox-link-container": `login_checkbox-link-container__gX9WP`,
	"checkbox-wrapper": `login_checkbox-wrapper__semla`,
	"forgot-password": `login_forgot-password__tAZX7`,
	"registration": `login_registration__GRv+i`,
	"registration-link": `login_registration-link__2gloN`,
	"footer-actions": `login_footer-actions__0G9ww`,
	"footer-actions-wrapper": `login_footer-actions-wrapper__yiRAw`,
	"separator": `login_separator__b+LEr`,
	"separator-tertiary": `login_separator-tertiary__+vZDv`,
	"separator-secondary": `login_separator-secondary__fmCJ8`,
	"description": `login_description__atRgl`,
	"illustration": `login_illustration__6hjjb`
};
export default ___CSS_LOADER_EXPORT___;
